import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiChipStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            backgroundColor: variables.colors.other.chip.default.background,
            color: variables.colors.other.chip.default.text,
            fontSize: 10,
            fontWeight: 600,
        },
    },
});

export default createMuiChipStyles;
